const getters = {
  userId: state => state.user.userId,
  userInfo: state => state.user.userInfo,
  sessionKey: state => state.user.sessionKey,
  isShowLogin: state => state.user.isShowLogin,
  headerUserinfoShow: state => state.user.headerUserinfoShow
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js